<main class="c-main" role="main">
    <div class="c-page-confirmationcard">
        <div class="container">
            <div class="row mobile--orange u-pt30 u-pb30">
                <div class="col-md-12" >
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a >{{'SaaDelegateConfirmationPortal.home' |translate}}</a></li>
                            <li class="breadcrumb-item active" aria-current="page">&nbsp;-&nbsp;</li><span> {{'SaaDelegateConfirmationPortal.location' |translate}}</span>
                        </ol>
                    </nav>
                    <h2  class="o-title">{{'SaaDelegateConfirmationPortal.title' |translate}} </h2>
                </div>
            </div>
        </div>
        <section class="c-results">
            <div class="container u-pt40 u-pb60">
                <div class="row">
                    <div class="col-md-10 col-md-offset-1">
                        <div class="o-steps">
                            <div class="row">
                                <div class="col-md-10 col-md-offset-1">
                                    <div class="row">
                                      <div class="col-xs-6 col-xs-offset-3 o-steps__step o-steps__step--single o-steps__step--approved">
                                        <div   class="o-steps__circle"><i class="icon icon-check"></i></div>
                                      </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <h2 class="o-title o-title--medium o-title--center js-txt4 " >{{'SaaDelegateConfirmationPortal.bodyName' |translate}} <br>{{name}}</h2>                  
                        <div class="row u-pt20">
                            <div class="col-md-10 col-md-offset-1">
                                <div class="u-pt40 u-pb30 u-mb40 center c-results__box">
                                    <p></p>
                                    <p>{{'SaaDelegateConfirmationPortal.bodyEmail' |translate}} {{email}}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="row u-pt20">
                            <div class="col-md-6 col-md-offset-3" >
                                <a class="btn btn--full btn--primary" [routerLink]="['/saa-delegate']">
                                    {{'SaaDelegateConfirmationPortal.buttonBack' |translate}} </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</main>